import IssuesStore, { initialIssuesState } from '../stores/issues-store';
import createIssueStoreActions from '../../common/store-actions/create-issue-store-actions';

const issueStoreActions = createIssueStoreActions(
  IssuesStore,
  initialIssuesState,
);

// https://stackoverflow.com/questions/29844074/es6-export-all-values-from-object
export const setStoreIssues = issueStoreActions.setStoreIssues;
export const setStoreTotalIssues = issueStoreActions.setStoreTotalIssues;
export const setStoreTotalIssuesFiltered =
  issueStoreActions.setStoreTotalIssuesFiltered;
export const setStoreIssuesOffset = issueStoreActions.setStoreIssuesOffset;
export const setStoreIssuesFiltersType =
  issueStoreActions.setStoreIssuesFiltersType;
export const setStoreIssuesFiltersTypeSearch =
  issueStoreActions.setStoreIssuesFiltersTypeSearch;
export const setModalVisibility = issueStoreActions.setModalVisibility;
export const closeIssueModal = issueStoreActions.closeIssueModal;
export const closeIssueModalWithoutNavigate =
  issueStoreActions.closeIssueModalWithoutNavigate;
export const openIssueModal = issueStoreActions.openIssueModal;
export const setSelectedIssue = issueStoreActions.setSelectedIssue;
export const toggleFiltersPanel = issueStoreActions.toggleFiltersPanel;
export const clearFilters = issueStoreActions.clearFilters;
export const clearStore = issueStoreActions.clearStore;
export const setPolicyDisableModal = issueStoreActions.setPolicyDisableModal;
export const setApplicationIrrelevantModal =
  issueStoreActions.setApplicationIrrelevantModal;
export const setShowCreateJiraTicketDialog =
  issueStoreActions.setShowCreateJiraTicketDialog;
export const setShowSendSlackMessageDialog =
  issueStoreActions.setShowSendSlackMessageDialog;
export const openQuickFixModal = issueStoreActions.openQuickFixModal;
export const setQuickFixModalVisibility =
  issueStoreActions.setQuickFixModalVisibility;
export const setPolicyFixModal = issueStoreActions.setPolicyFixModal;
export const openQuickFixPermissionDeniedModal =
  issueStoreActions.openQuickFixPermissionDeniedModal;
export const setQuickFixPermissionDeniedModalVisibility =
  issueStoreActions.setQuickFixPermissionDeniedModalVisibility;
export const setFilesDiffModalVisibility =
  issueStoreActions.setFilesDiffModalVisibility;
export const setSliderValuePriority = issueStoreActions.setSliderValuePriority;
export const setLastDrawerHeight = issueStoreActions.setLastDrawerHeight;
export const setIsActiveJiraConnection =
  issueStoreActions.setIsActiveJiraConnection;
export const setIsActiveSlackConnection =
  issueStoreActions.setIsActiveSlackConnection;
export const pushSlackNotificationToRawIssue =
  issueStoreActions.pushSlackNotificationToRawIssue;
export const setSelectedIssueId = issueStoreActions.setSelectedIssueId;
export const setExclusionIssueComment =
  issueStoreActions.setExclusionIssueComment;
export const setExclusionPolicyComment =
  issueStoreActions.setExclusionPolicyComment;
export const setExclusionAppComment = issueStoreActions.setExclusionAppComment;
export const addJiraTicketToRawIssue =
  issueStoreActions.addJiraTicketToRawIssue;
export const setJiraTicketsToRawIssue =
  issueStoreActions.setJiraTicketsToRawIssue;
export const addJiraTicketToSelectedIssue =
  issueStoreActions.addJiraTicketToSelectedIssue;
export const setDrawerJiraTicketsStatus =
  issueStoreActions.setDrawerJiraTicketsStatus;
export const setLoadingIssue = issueStoreActions.setLoadingIssue;
export const setStoreIssuesStatistics =
  issueStoreActions.setStoreIssuesStatistics;
export const setStoreTotalResolvedIssues =
  issueStoreActions.setStoreTotalResolvedIssues;
export const setStoreTotalActiveIssues =
  issueStoreActions.setStoreTotalActiveIssues;
export const setCommentModal = issueStoreActions.setCommentModal;
export const setIssueCommentTemp = issueStoreActions.setIssueCommentTemp;
export const setIssueComment = issueStoreActions.setIssueComment;
export const setLoadingJiraStatusUpdate =
  issueStoreActions.setLoadingJiraStatusUpdate;
export const setSearchValues = issueStoreActions.setSearchValues;
export const clearFilter = issueStoreActions.clearFilter;
export const setSnoozeIssueExpiredDate =
  issueStoreActions.setSnoozeIssueExpiredDate;
export const setSearchValue = issueStoreActions.setSearchValue;
export const onSearchValueChange = issueStoreActions.onSearchValueChange;
